<template lang="pug">
  .scroll-to(
    @click="scrollToSection"
  )
    icon.scroll-to__arrow(
      name="arrow-left"
      size="18px"
      :style="iconStyles"
    )
    span.scroll-to__text {{ ctaText }}
</template>

<script>
  import Icon from 'scripts/components/basic/Icon.vue';

  export default {
    name: 'ScrollTo',
    components: {
      Icon,
    },
    props: {
      scrollSelector: String,
      fillColor: String,
      ctaText: String,
    },
    computed: {
      iconStyles() {
        if (['mobile', 'tablet'].includes(this.$mq)) return;
        return {
          fill: this.fillColor,
        };
      }
    },
    methods: {
      scrollToSection() {
        if (!this.scrollSelector) return;
        const scrollToElement = document.querySelector(this.scrollSelector);
        scrollToElement.scrollIntoView({
          behavior: 'smooth',
        });
      }
    },
  };
</script>

<style lang="scss" scoped>
  .scroll-to {
    padding: 10px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .scroll-to__arrow {
    margin-right: $grid-gutter;
    transform: rotate(-90deg);

    .scroll-to:hover & {
      transform: rotate(-90deg) translateX(-12px);
    }
  }

  .scroll-to__text {
    font-family: $font-gibson;
  }
</style>
